var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'tw-w-full',
    {
      'sm:tw-w-[48%] lg:tw-w-full': !_vm.resourceEditable,
    },
  ]},[_c('button',{staticClass:"button button-block button-outlined",attrs:{"disabled":_vm.disabled},on:{"click":_vm.loadPreview}},[_vm._v("\n    Preview File\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }